export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2">
          <span className="w-2 h-6 md:h-7 rounded-full bg-accent-500"></span>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-50">关于桃子影院</h2>
        </div>
        <p className="text-sm text-foreground-400 mb-8 md:mb-10">致力于为影迷提供极致的免费在线观影体验</p>

        <div className="rounded-2xl bg-background-50 border border-background-200/40 p-6 md:p-8">
          <div className="max-w-3xl">
            <p className="text-sm md:text-base text-foreground-200 leading-relaxed mb-4">
              桃子影院创立于2019年，是国内领先的免费在线电影观看平台。我们汇聚了超过10万部电影大全资源，涵盖最新电影、热门电影排行榜、经典华语电影等丰富内容，每日持续更新片库，确保影迷第一时间获取优质观影资源。
            </p>
            <p className="text-sm md:text-base text-foreground-200 leading-relaxed mb-4">
              平台采用先进的分布式CDN加速与智能码率自适应技术，从高清到超清、蓝光再到4K影视，多种清晰度自由切换，真正做到永久免费不缓冲、秒开播放。无论您身在何处，用电脑、手机或平板，都能享受流畅的高品质观影。
            </p>
            <p className="text-sm md:text-base text-foreground-200 leading-relaxed">
              桃子影院始终秉持&ldquo;好电影，零门槛&rdquo;的理念，不设会员、不插广告、不限制播放次数，让每一位热爱电影的朋友都能纯粹地享受光影世界。我们持续优化观影体验，定期推出专题合集与热门话题，帮助您在海量片库中快速找到心仪之作。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}